import React from 'react';
import { Button as ButtonBase, ButtonProps } from '@cp/ds/src/components/button';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useIsFavorite } from '@cp/entities/client/current/favorite/model/useIsFavorite';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { HeartFilledIcon } from '@cp/ds/src/icons/heartFilled';
import { HeartBoldIcon } from '@cp/ds/src/icons/heartBold';
import { SVGIconTokens } from '@cp/ds/src/components/svgIcon';
import { useQueryFavorites, useToggleFavorite } from 'src/features/client/current/favorite';
import { withTrackClick } from 'src/shared/tracking';
import { CatalogEvents } from 'src/features/catalog';
import { FavoriteProps, FavoriteVariant } from './model';

export * from './model';

const Button = withTrackClick(ButtonBase, CatalogEvents.ItemLike);

export const Favorite: React.FC<FavoriteProps> = ({ authorId, variant = FavoriteVariant.text, ...restProps }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  // const login = useClientLogin();
  const isFavorite = useIsFavorite(authorId);
  const toggleFavorite = useToggleFavorite(authorId);
  const { isFavoritesLoading } = useQueryFavorites();

  const currentIconColor = isFavorite ? 'brand pink' : 'inherit';
  const favoriteButtonLabel = isFavorite ? 'Избранное' : 'Мне нравится';
  const ActionIcon = isFavorite ? HeartFilledIcon : HeartBoldIcon;

  const handleToggleFavorite: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    toggleFavorite();
  };

  const buttonProps: ButtonProps = {
    ...restProps,
    variant: 'secondary',
    disabled: isFavoritesLoading,
    onClick: handleToggleFavorite,
    sx: mergeSx(
      {
        [SVGIconTokens.Size]: { xs: '16px', md: '20px' },
        width: { md: '360px' },
        backgroundColor: theme.palette.white,
        borderColor: theme.palette['gray middle'],
        whiteSpace: 'nowrap',
        zIndex: 50,
      },
      restProps?.sx,
    ),
  };

  if (variant === FavoriteVariant.icon) {
    return (
      <Button {...buttonProps} square>
        <ActionIcon sx={{ color: `${currentIconColor}` }} />
      </Button>
    );
  }

  return (
    <Button iconRight={<ActionIcon sx={{ color: `${currentIconColor}` }} />} square={isMobile} {...buttonProps}>
      {isMobile ? <ActionIcon sx={{ color: `${currentIconColor}` }} /> : favoriteButtonLabel}
    </Button>
  );
};
